/** * Time in milliseconds
 */
export const CACHE_TIMES = {
    // How long data is considered "fresh" before checking the server again
    DEFAULT_STALE: 5 * 60 * 1000, // 5 Minutes

    // How long data stays in memory after the component unmounts
    DEFAULT_GC: 10 * 60 * 1000, // 10 Minutes

    // Use for static data like Company Info or Settings
    LONG_STALE: 60 * 60 * 1000, // 1 Hour
};
